import React from 'react'
import PropTypes from 'prop-types'

import Button from 'component/Button/index'
import FilterIconSVG from 'component/svgComponents/filter'

const Options = ({
  setOpenEditModal = () => {},
  setSideFilterVisible = () => {},
  translate = () => {},
}) => (
  <div className='float-right margin-top'>
    <Button
      className='btn btn-primary margin-right'
      onClick={setOpenEditModal}
      text={translate('justificationsPa.new.button')}
    />
    <Button
      className='btn btn-secondary'

      svgIcon
      svgComponent={ <FilterIconSVG className="margin-default-svg" newDesign={false} />}
      onClick={setSideFilterVisible}
      text={translate('mobile.filter')}
    />
  </div>
)

Options.propTypes = {
  setOpenEditModal: PropTypes.func.isRequired,
  setSideFilterVisible: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
}

export default Options
